'use strict';
/* globals google */

const urlUtils = require('../util/url');
const storeLocatorHelper = require('./storeLocatorHelper');
const countrySelectHelper = require('../components/localePreferences');
const { isMobile } = require('../util/responsive');

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 * @param {Object} centerPosition the latitude and longitude that will be used for the center
 * @param {string} radius the radius that will be used
 */
function updateStoresResults(data, centerPosition, radius) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    $('.js-store-locator-no-results').toggleClass('d-none', hasResults);
    $('.js-noShopsAlert').toggleClass('d-block', !hasResults);

    $resultsDiv
        .empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        storeLocatorHelper.maps(centerPosition, radius);
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * gets all the selected filters and returns them in a comma seperated string
 * @returns {string} all selected filters
 */
function findSelectedFilters() {
    var attr = '';
    $('input[name^="filter-"]').each(function () {
        if ($(this).is(':checked')) {
            attr += $(this).attr('id') + ',';
        }
    });

    return attr.substring(0, attr.length - 1);
}

/**
 * Handles findStores call triggered by the storeLocatorFields.isml form
 * @param {string} url - Url
 * @param {Object} payload - params
 * @param {jQuery} $form - form element
 */
function handleSearchAjax(url, payload, $form) {
    payload.isCheckout = !!$('.js-isCheckout').length;
    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            $.spinner().stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
            $('.storeLocator-filters').data('action', data.actionUrl); // Stores-findStores + parameters
            storeLocatorHelper.calculateCurrentlyOpen();
            storeLocatorHelper.getLocation();
            $('body').trigger('stores:loaded');
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    $.spinner().start();

    var $form = element.closest('.store-locator');
    var radius = $('.radius').val();
    var url = $form.attr('action');
    var urlParams = {
        radius: radius,
        attributes: findSelectedFilters()
    };

    var postalCode = $form.find('[name="postalCode"]').val();
    var country = $form.find('[name="storeCountry"]').val();
    var countryID = $('option:selected', $form.find('[name="storeCountry"]')).attr('id');
    var googleMapsUrl = $form.data('googlemapsurl');
    var googleMapsUrlParams = {
        address: postalCode + ' ' + country
    };

    googleMapsUrl = urlUtils.addOrReplaceQueryParameters(googleMapsUrl, googleMapsUrlParams);

    $.ajax({
        url: googleMapsUrl,
        type: 'get',
        success: function (data) {
            var location = data.results[0] ? data.results[0].geometry.location : {};
            var payload = {
                lat: location.lat,
                long: location.lng,
                postalCode: postalCode,
                storeCountry: countryID
            };

            url = urlUtils.addOrReplaceQueryParameters(url, urlParams);

            handleSearchAjax(url, payload, $form);
        },
        error: function () {
            $.spinner().stop();
        }
    });

    return false;
}

/**
 * Disables filter that can not be combined with others
 * @param {jQuery} filter - current filter
 */
function handleFilterCombo(filter) {
    var currentAttrID = filter.attr('id');
    var isPartnerStore = $('#isPartnerStore');
    var isFlagship = $('#isFlagship');
    var hasChocomouse = $('#hasChocomouse');

    var isFlagShipChecked = isFlagship && isFlagship.length && isFlagship[0].checked;
    var hasChocomouseChecked = hasChocomouse && hasChocomouse.length && hasChocomouse[0].checked;

    if (currentAttrID === 'isPartnerStore') {
        isFlagship.prop('disabled', filter[0].checked);
        hasChocomouse.prop('disabled', filter[0].checked);

        isFlagship.siblings('.form-check-label').toggleClass('text-muted', filter[0].checked);
        hasChocomouse.siblings('.form-check-label').toggleClass('text-muted', filter[0].checked);
    }
    if (currentAttrID === 'isFlagship' || currentAttrID === 'hasChocomouse') {
        isPartnerStore.prop('disabled', isFlagShipChecked || hasChocomouseChecked);
        isPartnerStore.siblings('.form-check-label').toggleClass('text-muted', isFlagShipChecked || hasChocomouseChecked);
    }
}

module.exports = {
    init: function () {
        if (storeLocatorHelper.initMap()) {
            $('.btn-storelocator-search').attr('disabled', false);
            storeLocatorHelper.getLocation();
            storeLocatorHelper.calculateCurrentlyOpen();
            countrySelectHelper.handleAlphabeticalSort($('#storeCountry'));

            // Default filters are open (needed for desktop), close them on mobile
            if (isMobile()) {
                $('.storeLocator-filters .filter-toggle').trigger('click');
            }
        }
        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition((position) => {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.radius').val();
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    attributes: findSelectedFilters(),
                    isCheckout: !!$('.js-isCheckout').length
                };
                url = urlUtils.addOrReplaceQueryParameters(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(
                            data,
                            new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            ),
                            radius
                        );
                        $('.select-store').prop('disabled', true);
                        $('.storeLocator-filters').data('action', data.actionUrl); // Stores-findStores + parameters
                        storeLocatorHelper.calculateDistances(position);
                        storeLocatorHelper.calculateCurrentlyOpen();
                        $('body').trigger('stores:loaded');
                    }
                });
            }, function () {
                $.spinner().stop();
                // todo notify user something went wrong?
            }, { timeout: 10000 });
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search')
            .click(function (e) {
                e.preventDefault();
                search($(this));
            });
    },

    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore
                    .siblings('label')
                    .find('.store-details')
                    .html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        });
    },

    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', function () {
            $('.select-store').prop('disabled', false);
        });
    },

    initFilters: function () {
        $('body').on('change', 'input[name^="filter-"]', function () {
            // prevent selecting more than 4 filters
            if ($('input[name^="filter-"]:checked').length >= 4) {
                $('input[name^="filter-"]:not(:checked)').attr('disabled', true);
                $('input[name^="filter-"]:not(:checked)').siblings('.form-check-label').addClass('text-muted');
            } else {
                $('input[name^="filter-"]').removeAttr('disabled');
                $('input[name^="filter-"]').siblings('.form-check-label').removeClass('text-muted');
                $('input[name^="filter-"]').each(function () {
                    handleFilterCombo($(this));
                });
            }

            var url = $('.storeLocator-filters').data('action'); // Stores-FindStores
            var newUrl = urlUtils.addOrReplaceQueryParameters(decodeURIComponent(url), {
                attributes: findSelectedFilters()
            });

            if (url) {
                $.spinner().start();
                $.ajax({
                    url: newUrl,
                    method: 'GET',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        storeLocatorHelper.getLocation();
                        storeLocatorHelper.calculateCurrentlyOpen();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    }
};
